import React from 'react'

//import { roundBy } from "./../util/utility"

import ReactMapGL, { Marker } from 'react-map-gl';
import { mapStyle } from "./settings/mapStyle"


class Legend extends React.Component {

  constructor(props){
    super(props)

    this.state = {
      viewport: {
        latitude: 52.332952,
        longitude: 4.846400,
        zoom: 11
      }
    }
  }

  onViewportChange = viewport => { 
    const {width, height, ...etc} = viewport
    this.setState({viewport: etc})
  } 

  render() {
    //const { locationParameters, data, parameters } = this.props

    return (
      <div className="columns" style={{ padding: "0 2rem" }}>
        <div className="column column-width-s-12 column-width-m-7 column-width-l-7">
          <div id="map">
            <ReactMapGL width="100%" height="100%" {...this.state.viewport} onViewportChange={viewport => this.onViewportChange(viewport)} mapStyle={mapStyle}>
              <Marker latitude={52.332952} longitude={4.846400} offsetLeft={-10} offsetTop={-20}>
                <h3>AmsterDeck Nieuwe Meer</h3>
              </Marker>
            </ReactMapGL>
          </div>
          <h3>Waterkwaliteit en omgevingsfactoren van de Nieuwe Meer</h3>
          <p>De Nieuwe Meer is onderdeel van de boezem van het Hoogheemraadschap van Rijnland. Aan de westzijde in de Oeverlanden zijn twee officiële zwemwaterlocaties. Op de Nieuwe Meer storten geen riolen over. De kans op slechte bacteriologische waterkwaliteit is dan ook gering. Het belangrijkste gevaar voor zwemmers (buiten de officiële zwemwaterlocaties) is de scheep- en recreatievaart.</p>
          <p>Om te voorkomen dat door concentraties aan stikstof en fosfaat blauwalgen ontstaan, ligt er een beluchtingsinstallatie. Door lucht te pompen in slangen die op de bodem van de plas liggen, ontstaan luchtbellenschermen. Deze brengen het water in beweging en zorgen voor stroming. De blauwalgen, die in de bovenste waterlaag voldoende licht hebben om te groeien, worden door de stroming meegevoerd naar de diepe en donkere delen van de plas. In het donker kunnen ze niet meer groeien en sterven ze af.</p>
          <p><a className="button" href="/over-waterkwaliteit/zwemwaterkwaliteit/">Meer over zwemwaterkwaliteit</a></p>
        </div>
        <div className="column column-width-s-12 column-width-m-5 column-width-l-5">
          <h3>Wat zie ik in de grafiek?</h3>
          <p>In de grafiek hierboven zie je meetgegevens van temperatuur, zuurstof, geleidbaarheid en zuurgraad (ph). Je kunt de metingen bekijken per dag, week, maand en jaar. Voor elke parameter geeft de stippellijn het gemiddelde aan en de kleurband de laagst en hoogst gemeten waarde in die periode. Hoe breder die kleurband, hoe groter de variatie in die periode.</p>
          <p>Wanneer de waarden naar geel en rood gaan bestaat er kans op slechtere waterkwaliteit. Klik op uitroeptekens om meer te weten te komen over deze risico's en de mogelijke oorzaken.</p>
        </div>
      </div>
    )
  }
}


export default Legend